var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.to ? "a" : "div",
    _vm._b(
      {
        tag: "component",
        staticClass: "card h-100 shadow-sm btn-widget text-decoration-none",
        class: "border-left-" + _vm.variant,
        on: {
          click: function ($event) {
            return _vm.$emit("click")
          },
        },
      },
      "component",
      _vm.to ? { href: _vm.to } : {},
      false
    ),
    [
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          {
            staticClass: "text-uppercase font-weight-bold font-xs mb-1",
            class: "text-" + _vm.variant,
          },
          [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
        ),
        _vm._v(" "),
        _vm.subTitle
          ? _c("div", { staticClass: "small text-muted mb-2" }, [
              _vm._v(_vm._s(_vm.subTitle)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "h3 mb-0 font-weight-bold text-gray-800" }, [
          _vm.loading
            ? _c(
                "div",
                {
                  staticClass: "spinner-border spinner-border-sm",
                  attrs: { role: "status" },
                },
                [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v("Cargando..."),
                  ]),
                ]
              )
            : _c("span", [_vm._v(_vm._s(_vm.value))]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }